export default {"src":"/_next/static/media/enerflo-team-icon.3cf8bdee.svg","height":56,"width":88};